import { render } from "./App.vue?vue&type=template&id=0299f5eb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0299f5eb&lang=scss"

import exportComponent from "/var/www/md_tele_vue/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__